import { createContext } from "react";

export const HouseContext = createContext(null);